export const environment = {
  production: false,
  apiURL: "/ceapi/",
  // apiURL: "https://ce2.creative123.net/ceapi/",
  // apiURL: "https://demo.creative123.net/ceapi/",
  // apiURL: "http://localhost:8080/ceapi/",
  // apiURL: "/ceapi/",
  // apiURL: "https://demo.creative123.net/ceapi/",
  // imageUrl: "https://ce2.creative123.net/ceapi/",
  // apiURL: "/ceapi/",
  imageUrl: "/ceapi/",
  imagePath: "/opt/tomcat/webapps/temp/emaorderform/assets"
  // apiURL: "http://localhost:3000/api/v1/",
  // imageUrl: "http://localhost:3000/",x
};